import { changePassword } from "@root/graphql/changePassword.gql";
export default {
  namespaced: true,
  state: {},
  actions: {
    async changePasswordFn({ rootState }: any, data?: any) {
      let res = await rootState.gql.mutate({
        mutation: changePassword,
        variables: { ...data }
      });
      return res.success;
    }
  },
  mutations: {}
};
